export class ErrorData {
  statusCode: number;
  message: string;
  error: string;
  params?: Record<string, string>;

  constructor(errorData?: ErrorData | null) {
    this.statusCode = errorData?.statusCode ?? 0;
    this.message = errorData?.message ?? '';
    this.error = errorData?.error ?? '';
    this.params = errorData?.params ?? {};
  }
}

export interface Pagination {
  totalCount: number;
  skip: number;
  take: number;
}

export type PaginateQuery<T> = {
  results: T[];
  count: number;
  next: string | null;
  previous: string | null;
};

export interface FetchResponse<T> {
  status: number;
  statusText: string;
  ok: boolean;
  type: string;
  url: string;
  data?: T;
  errors?: Array<{ message: string }>;
}

export interface ServerResponse<T> {
  data: T;
  totalCount: number;
}

export interface FetchParams {
  search?: string;
  sort?: string;
  skip?: number;
  take?: number;
  show?: string;
}

export type PaginationParams = {
  skip: number;
  take: number;
};

export type FilterParams<T> = {
  search: string;
  sort: string;
} & T;

export type ShowParams = {
  show: string;
};

export type AllParams<T> = Partial<
  PaginationParams & FilterParams<T> & ShowParams
>;

export type SortType = 'asc' | 'desc';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TSFixMe = any;
